import { Component, computed, inject, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { selectFavoriteAssistants } from '../../../favorites/favorites.selectors';
import * as fromLayout from '../../../layout';
import * as fromAssistants from '../../assistants';
import { RECENT_CHATS_LIMIT } from '../../chats.constants';
import { chatsFeature, ChatsState } from '../../store';
import * as fromTeammates from '../../teammates';
import { NavigationChatsListSmartComponent } from './navigation-chats-list.smart.component';
import { NavigationFavoritesListSmartComponent } from './navigation-favorites-list.smart.component';
import { NavigationTeammatesListSmartComponent } from './navigation-teammates-list.smart.component';

@Component({
  selector: 'squadbox-navigation-smart',
  imports: [
    TranslateModule,
    RouterModule,
    fromAssistants.AssistantLogoComponent,
    NavigationChatsListSmartComponent,
    NavigationFavoritesListSmartComponent,
    NavigationTeammatesListSmartComponent,
  ],
  template: `
    <div
      class="
        h-full w-full
        overflow-y-auto hide-scrollbar
      "
    >
      <div
        class="
          flex flex-col gap-6
          pt-12 pb-4 tablet-portrait:pt-8
        "
      >
        <squadbox-navigation-teammates-list-smart
          class="px-4 tablet-portrait:px-1"
          [teammatesList]="teammatesList()"
        />
        @if (favoritesList().length) {
          <squadbox-navigation-favorites-list-smart
            class="tablet-portrait:px-1"
            [favoritesList]="favoritesList()"
          />
        }
        <squadbox-navigation-chats-list-smart
          class="tablet-portrait:px-1"
          [label]="'MAIN_NAVIGATION_ITEMS.MY_CHATS' | translate"
          [chatNavigationItems]="chatNavigationItems()"
          [source]="'menu'"
          (chatDeleteClicked)="chatDeleteClicked.emit($event)"
        />
      </div>
    </div>
  `,
})
export class NavigationSmartComponent {
  private readonly layoutStore = inject<Store<fromLayout.LayoutState>>(Store);
  private readonly assistantsStore = inject(Store);
  private readonly chatsStore = inject<Store<ChatsState>>(Store);
  private readonly teammatesStore =
    inject<Store<fromTeammates.TeammatesState>>(Store);

  public readonly chatDeleteClicked = output<string>();

  public readonly isMobile = this.layoutStore.selectSignal(
    fromLayout.layoutFeature.selectIsMobile,
  );
  public readonly favoritesList = this.assistantsStore.selectSignal(
    selectFavoriteAssistants,
  );
  public readonly teammatesList = this.teammatesStore.selectSignal(
    fromTeammates.teammatesFeature.selectAllWithAssistants,
  );
  public readonly chatNavigationItems = computed(() =>
    this.chatsStore
      .selectSignal(chatsFeature.selectChatNavigationItems)()
      .slice(0, RECENT_CHATS_LIMIT),
  );
}
